import { getCustomerProfile } from '../services/backendClient'

export const API_CUSTOMER_PROFILE = 'API_CUSTOMER'

export const getCustomerInfo = () => ({
  type: API_CUSTOMER_PROFILE,
  promise: getCustomerProfile()
})
